/* eslint-disable no-undef */
export default {
	name: "product-select-collection-order",
	props: ["companyId", "depotId"],
	emits: ["productSelected"],
	data() {
		return {
			products: [],
			productHeadings: [
				{
					text: "Product",
					field: "product"
				},
				{
					text: "Price",
					field: "price"
				},
				{
					text: "Discounted Amount",
					field: "discountAmountAsString"
				},
				{
					text: "Price After Discount",
					field: "priceAfterDiscountAsString"
				},
				{
					text: "Quantity",
					field: "quantity"
				}
			],
			pagingDetails:{
				pageNumber: 1,
				pageSize: 100,
				totalPages: 1
			},
			filter:{
				searchQuery: null,
				customerSearchQuery: null,
				activeOrInactiveItems: 1
			},
			orderTotal: 0,
			orderTotalAsString: null,
			newAssignedCustomers: [],
			newUnassignedCustomers: [],
			modalHeading: null,
			modalComponentId: null,
			formIsSaving: false,
			showSuccessMessage: false,
			successMessage: null,
			showErrorMessage: false,
			errorMessage: null,
			loading: false,
			comboDiscountGroups: [],
			comboDiscountGroupProducts: []
		};
	},
	methods: {
		getComboDiscountGroups(){
			let request = {
				pageNumber: 1,
				pageSize: 1000,
				searchQuery: null,
				isActive: true
			};
			orderService.getComboDiscountGroups(request).then(
				successResponse => {
					let isSuccess = apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(successResponse.data.responseStatus, successResponse.data.httpStatusCode, successResponse.data.message);
					if(isSuccess){
						// Filter out combo discount groups with future effective dates
						const currentDate = new Date();
						this.comboDiscountGroups = successResponse.data.result.filter(group => {
							if(group.effectiveDate){
								const effectiveDate = new Date(group.effectiveDate);
								return effectiveDate <= currentDate;
							}
							return true;
						});
						this.loadComboDiscountGroupProducts();
					}
				},
				errorResponse => {
					console.log("Error fetching combo discount groups", errorResponse);
					apiResponseHandlerHelepr.displaySessionExpiredMessage(errorResponse.response.status);
				}
			);
		},
		loadComboDiscountGroupProducts(){
			this.comboDiscountGroupProducts = [];
			const promises = this.comboDiscountGroups.map(group => {
				return orderService.getComboDiscountGroupProductsByComboDiscountGroup(group.comboDiscountGroupId)
					.then(response => {
						let isSuccess = apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(response.data.responseStatus, response.data.httpStatusCode, response.data.message);
						if(isSuccess){
							return {
								comboDiscountGroupId: group.comboDiscountGroupId,
								products: response.data.result || []
							};
						}
						return null;
					})
					.catch(error => {
						console.log("Error fetching combo discount group products for group", group.comboDiscountGroupId, error);
						return null;
					});
			});

			Promise.all(promises).then(results => {
				results.forEach(result => {
					if(result){
						this.comboDiscountGroupProducts.push(result);
					}
				});
			});
		},
		findComboDiscountGroupsForProduct(productId){
			const foundGroups = [];
			for(let i = 0; i < this.comboDiscountGroupProducts.length; i++){
				const groupProducts = this.comboDiscountGroupProducts[i];
				for(let j = 0; j < groupProducts.products.length; j++){
					if(groupProducts.products[j].productId === productId){
						foundGroups.push({
							comboDiscountGroupId: groupProducts.comboDiscountGroupId,
							group: this.comboDiscountGroups.find(g => g.comboDiscountGroupId === groupProducts.comboDiscountGroupId),
							products: groupProducts.products
						});
						break; // Break inner loop since we found the product in this group
					}
				}
			}
			return foundGroups;
		},
		findComboDiscountGroupForProduct(productId){
			const groups = this.findComboDiscountGroupsForProduct(productId);
			return groups.length > 0 ? groups[0] : null;
		},
		removeComboDiscountFromGroup(comboDiscountGroupId){
			// Find all products that have combo discount from this specific group
			for(let i = 0; i < this.products.length; i++){
				if(this.products[i].hasComboDiscount){
					// Check if this product belongs to the combo group being removed
					const groupInfos = this.findComboDiscountGroupsForProduct(this.products[i].productId);
					const belongsToGroup = groupInfos.some(group => group.comboDiscountGroupId === comboDiscountGroupId);
					
					if(belongsToGroup){
						// Remove combo discount from this product
						this.products[i].discountAmount = null;
						this.products[i].discountedAmountTotal = 0;
						this.products[i].discountAmountAsString = null;
						this.products[i].priceAfterDiscount = null;
						this.products[i].priceAfterDiscountAsString = null;
						this.products[i].totalAfterDiscount = null;
						this.products[i].totalAfterDiscountAsString = null;
						this.products[i].hasComboDiscount = false;
					}
				}
			}
		},
		reEvaluateDiscountsForSelectedProducts(){
			// Get all currently selected products
			const allSelectedProducts = this.products.filter(p => p.selected);
			
			if(allSelectedProducts.length === 0){
				return;
			}
			
			// Reset all combo discount flags for selected products
			for(let i = 0; i < this.products.length; i++){
				if(this.products[i].selected){
					this.products[i].hasComboDiscount = false;
				}
			}
			
			// First, try to apply combo discounts
			const processedGroups = new Set();
			let hasAppliedComboDiscount = false;
			
			// Check each selected product for combo groups
			for(let selectedProduct of allSelectedProducts){
				const comboGroupInfos = this.findComboDiscountGroupsForProduct(selectedProduct.productId);
				
				for(let comboGroupInfo of comboGroupInfos){
					// Skip if we've already processed this group
					if(processedGroups.has(comboGroupInfo.comboDiscountGroupId)){
						continue;
					}
					
					// Check if all products in this combo group are selected
					if(this.hasAllComboProductsSelected(comboGroupInfo.products, allSelectedProducts)){
						// Apply combo discounts to all products in the group that have applyDiscount = true
						for(let i = 0; i < this.products.length; i++){
							if(this.products[i].selected && !this.products[i].hasComboDiscount){
								const productInGroup = comboGroupInfo.products.find(p => p.productId === this.products[i].productId);
								if(productInGroup){
									if(this.applyComboDiscount(this.products[i], comboGroupInfo)){
										hasAppliedComboDiscount = true;
									}
								}
							}
						}
						processedGroups.add(comboGroupInfo.comboDiscountGroupId);
					}
				}
			}
			
			// Apply regular discounts to products that don't have combo discounts
			const regularDiscountPromises = [];
			for(let i = 0; i < this.products.length; i++){
				if(this.products[i].selected && !this.products[i].hasComboDiscount && !this.products[i].discountAmount){
					const currentProduct = this.products[i];
					currentProduct.loading = true;
					let request = {
						productId: currentProduct.productId,
						companyId: this.companyId,
						depotId: this.depotId
					};

					const promise = orderService.getDiscountForCompanyAndProduct(request).then(
						successResponse => {
							let isSuccess = apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(successResponse.data.responseStatus, successResponse.data.httpStatusCode, successResponse.data.message);
							if(isSuccess){
								let response = successResponse.data;
								if(response.hasDiscountAmount){
									currentProduct.discountAmount = response.discountAmount;
									currentProduct.discountedAmountTotal = currencyHelper.roundToTwoDecimalPlaces(currentProduct.quantity * currentProduct.discountAmount);
									currentProduct.discountAmountAsString = currencyHelper.numberToCurrency(currentProduct.discountAmount);
									currentProduct.priceAfterDiscount = currencyHelper.roundToTwoDecimalPlaces(currentProduct.price - currentProduct.discountAmount);
									currentProduct.priceAfterDiscountAsString = currencyHelper.numberToCurrency(currentProduct.priceAfterDiscount);
									currentProduct.totalAfterDiscount = currencyHelper.roundToTwoDecimalPlaces(currentProduct.quantity * currentProduct.priceAfterDiscount);
									currentProduct.totalAfterDiscountAsString = currencyHelper.numberToCurrency(currentProduct.totalAfterDiscount);
								}
							}
							currentProduct.loading = false;
						},
						errorResponse => {
							console.log("errorResponse", errorResponse);
							apiResponseHandlerHelepr.displaySessionExpiredMessage(errorResponse.response.status);
							currentProduct.loading = false;
						}
					);
					regularDiscountPromises.push(promise);
				}
			}
			
			// Wait for all regular discount API calls to complete, then recalculate totals
			Promise.all(regularDiscountPromises).then(() => {
				this.calculateGrandTotalForOrder();
			});
		},
		reEvaluateComboDiscountsAfterRegularDiscounts(){
			// Get all currently selected products
			const allSelectedProducts = this.products.filter(p => p.selected);
			
			if(allSelectedProducts.length === 0){
				return;
			}
			
			// Check if any combo groups now have all their products selected
			const processedGroups = new Set();
			let hasAppliedComboDiscount = false;
			
			// Check each selected product for combo groups
			for(let selectedProduct of allSelectedProducts){
				const comboGroupInfos = this.findComboDiscountGroupsForProduct(selectedProduct.productId);
				
				for(let comboGroupInfo of comboGroupInfos){
					// Skip if we've already processed this group
					if(processedGroups.has(comboGroupInfo.comboDiscountGroupId)){
						continue;
					}
					
					// Check if all products in this combo group are selected
					if(this.hasAllComboProductsSelected(comboGroupInfo.products, allSelectedProducts)){
						// Remove regular discounts from products in this group first
						for(let i = 0; i < this.products.length; i++){
							if(this.products[i].selected){
								const productInGroup = comboGroupInfo.products.find(p => p.productId === this.products[i].productId);
								if(productInGroup && !this.products[i].hasComboDiscount){
									// Clear existing regular discount
									this.products[i].discountAmount = null;
									this.products[i].discountedAmountTotal = 0;
									this.products[i].discountAmountAsString = null;
									this.products[i].priceAfterDiscount = null;
									this.products[i].priceAfterDiscountAsString = null;
									this.products[i].totalAfterDiscount = null;
									this.products[i].totalAfterDiscountAsString = null;
									this.products[i].hasComboDiscount = false;
								}
							}
						}
						
						// Now apply combo discounts to all products in the group that have applyDiscount = true
						for(let i = 0; i < this.products.length; i++){
							if(this.products[i].selected && !this.products[i].hasComboDiscount){
								const productInGroup = comboGroupInfo.products.find(p => p.productId === this.products[i].productId);
								if(productInGroup){
									if(this.applyComboDiscount(this.products[i], comboGroupInfo)){
										hasAppliedComboDiscount = true;
									}
								}
							}
						}
						processedGroups.add(comboGroupInfo.comboDiscountGroupId);
					}
				}
			}
			
			return hasAppliedComboDiscount;
		},
		evaluateAndApplyComboDiscounts(allSelectedProducts){
			// Check if any combo groups now have all their products selected
			const processedGroups = new Set();
			let hasAppliedComboDiscount = false;
			
			// Check each selected product for combo groups
			for(let selectedProduct of allSelectedProducts){
				const comboGroupInfos = this.findComboDiscountGroupsForProduct(selectedProduct.productId);
				
				for(let comboGroupInfo of comboGroupInfos){
					// Skip if we've already processed this group
					if(processedGroups.has(comboGroupInfo.comboDiscountGroupId)){
						continue;
					}
					
					// Check if all products in this combo group are selected
					if(this.hasAllComboProductsSelected(comboGroupInfo.products, allSelectedProducts)){
						// Remove regular discounts from products in this group first
						for(let i = 0; i < this.products.length; i++){
							if(this.products[i].selected){
								const productInGroup = comboGroupInfo.products.find(p => p.productId === this.products[i].productId);
								if(productInGroup && !this.products[i].hasComboDiscount){
									// Clear existing regular discount
									this.products[i].discountAmount = null;
									this.products[i].discountedAmountTotal = 0;
									this.products[i].discountAmountAsString = null;
									this.products[i].priceAfterDiscount = null;
									this.products[i].priceAfterDiscountAsString = null;
									this.products[i].totalAfterDiscount = null;
									this.products[i].totalAfterDiscountAsString = null;
									this.products[i].hasComboDiscount = false;
								}
							}
						}
						
						// Now apply combo discounts to all products in the group that have applyDiscount = true
						for(let i = 0; i < this.products.length; i++){
							if(this.products[i].selected && !this.products[i].hasComboDiscount){
								const productInGroup = comboGroupInfo.products.find(p => p.productId === this.products[i].productId);
								if(productInGroup){
									if(this.applyComboDiscount(this.products[i], comboGroupInfo)){
										hasAppliedComboDiscount = true;
									}
								}
							}
						}
						processedGroups.add(comboGroupInfo.comboDiscountGroupId);
					}
				}
			}
			
			return hasAppliedComboDiscount;
		},
		hasAllComboProductsSelected(comboGroupProducts, selectedProducts){
			// Check if all products in the combo group are selected
			for(let i = 0; i < comboGroupProducts.length; i++){
				const comboProduct = comboGroupProducts[i];
				const isSelected = selectedProducts.some(selected => selected.productId === comboProduct.productId);
				if(!isSelected){
					return false;
				}
			}
			return true;
		},
		applyComboDiscount(product, comboGroupInfo){
			// Find the specific combo product info
			const comboProduct = comboGroupInfo.products.find(p => p.productId === product.productId);
			if(comboProduct && comboProduct.applyDiscount && comboProduct.discountAmount > 0){
				product.discountAmount = comboProduct.discountAmount;
				product.discountedAmountTotal = currencyHelper.roundToTwoDecimalPlaces(product.quantity * product.discountAmount);
				product.discountAmountAsString = currencyHelper.numberToCurrency(product.discountAmount);
				product.priceAfterDiscount = currencyHelper.roundToTwoDecimalPlaces(product.price - product.discountAmount);
				product.priceAfterDiscountAsString = currencyHelper.numberToCurrency(product.priceAfterDiscount);
				product.totalAfterDiscount = currencyHelper.roundToTwoDecimalPlaces(product.quantity * product.priceAfterDiscount);
				product.totalAfterDiscountAsString = currencyHelper.numberToCurrency(product.totalAfterDiscount);
				product.hasComboDiscount = true;
				return true;
			}
			return false;
		},
		getDepotProducts(){
			this.loading = true;
			let request = {
				searchQuery: this.filter.searchQuery,
				depotId: this.depotId,
				pageNumber: this.pagingDetails.pageNumber,
				pageSize: this.pagingDetails.pageSize,
				companyId: this.companyId
			};
			orderService.getOrderCollectionProductPricesForDepot(request).then(
				successResponse => {
					let isSuccess = apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(successResponse.data.responseStatus, successResponse.data.httpStatusCode, successResponse.data.message);
					if(isSuccess){
						this.products = successResponse.data.result;
						this.products = dataTableHelper.castFieldValues(this.products);
						for(let i = 0; i < this.products.length; i++){
							this.products[i].errorMessage = null;
							this.products[i].priceAsString = currencyHelper.numberToCurrency(this.products[i].price);
							this.products[i].quantity = 1;
							this.products[i].discountedAmountTotal = 0;
							this.products[i].discountAmountAsString = null;
							this.products[i].priceAfterDiscount = null;
							this.products[i].priceAfterDiscountAsString = null;
							this.products[i].totalAfterDiscount = null;
							this.products[i].totalAfterDiscountAsString = null;
							this.products[i].discountAmount = null;
							this.products[i].hasComboDiscount = false;
							this.products[i].total = this.products[i].quantity * this.products[i].price;
							this.products[i].totalAsString = currencyHelper.numberToCurrency(this.products[i].total);
							this.products[i].selected = false;
						}
					}
					this.loading = false;
				},
				errorResponse => {
					console.log("errorResponse", errorResponse);
					apiResponseHandlerHelepr.displaySessionExpiredMessage(errorResponse.response.status);
					this.loading = false;
				}
			);
		},
		getProducts(){
			let request = {
				shippingAddressId: this.shippingAddressId,
				companyId: this.companyId
			};
			this.products = orderService.getProducts();
			orderService.getCompanyProductPricesByShippingAddress(request).then(
				successResponse => {
					let isSuccess = apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(successResponse.data.responseStatus, successResponse.data.httpStatusCode, successResponse.data.message);
					if(isSuccess){
						this.products = successResponse.data.result;
						this.products = dataTableHelper.castFieldValues(this.products);
						for(let i = 0; i < this.products.length; i++){
							this.products[i].priceAsString = currencyHelper.numberToCurrency(this.products[i].basePrice);
							this.products[i].quantity = 1;
							this.products[i].discountedAmountTotal = 0;
							this.products[i].discountAmountAsString = null;
							this.products[i].priceAfterDiscount = null;
							this.products[i].priceAfterDiscountAsString = null;
							this.products[i].totalAfterDiscount = null;
							this.products[i].totalAfterDiscountAsString = null;
							this.products[i].errorMessage = null;
							this.products[i].hasComboDiscount = false;
							if(this.products[i].discountAmount !== null && this.products[i].discountAmount > 0){
								this.products[i].discountedAmountTotal = this.products[i].quantity * this.products[i].discountAmount;
								this.products[i].discountAmountAsString = currencyHelper.numberToCurrency(this.products[i].discountAmount);
								this.products[i].priceAfterDiscount = this.products[i].basePrice - this.products[i].discountAmount;
								this.products[i].priceAfterDiscountAsString = currencyHelper.numberToCurrency(this.products[i].priceAfterDiscount);
								this.products[i].totalAfterDiscount = this.products[i].quantity * this.products[i].priceAfterDiscount;
								this.products[i].totalAfterDiscountAsString = currencyHelper.numberToCurrency(this.products[i].totalAfterDiscount);
							}
							this.products[i].total = this.products[i].quantity * this.products[i].basePrice;
							this.products[i].totalAsString = currencyHelper.numberToCurrency(this.products[i].total);
							this.products[i].selected = false;
						}
					}
				},
				errorResponse => {
					console.log("errorResponse", errorResponse);
					apiResponseHandlerHelepr.displaySessionExpiredMessage(errorResponse.response.status);
				}
			);
		},
		getCollectionProductsForCustomerAndDepot(){
			this.products = [
				{
					productId: 1,
					product: "Diesel (50ppm)",
					basePrice: 10,
					discountedAmount: 0
				},
				{
					productId: 2,
					product: "Diesel (500ppm)",
					basePrice: 15,
					discountedAmount: 0
				}
			];
			this.products = dataTableHelper.castFieldValues(this.products);
			for(let i = 0; i < this.products.length; i++){
				this.products[i].priceAsString = currencyHelper.numberToCurrency(this.products[i].basePrice);
				this.products[i].quantity = 1;
				this.products[i].discountedAmountTotal = 0;
				this.products[i].discountAmountAsString = null;
				this.products[i].priceAfterDiscount = null;
				this.products[i].priceAfterDiscountAsString = null;
				this.products[i].totalAfterDiscount = null;
				this.products[i].totalAfterDiscountAsString = null;
				this.products[i].hasComboDiscount = false;
				
				this.products[i].loading = false;
				if(this.products[i].discountAmount !== null && this.products[i].discountAmount > 0){
					this.products[i].discountedAmountTotal = this.products[i].quantity * this.products[i].discountAmount;
					this.products[i].discountAmountAsString = currencyHelper.numberToCurrency(this.products[i].discountAmount);
					this.products[i].priceAfterDiscount = this.products[i].basePrice - this.products[i].discountAmount;
					this.products[i].priceAfterDiscountAsString = currencyHelper.numberToCurrency(this.products[i].priceAfterDiscount);
					this.products[i].totalAfterDiscount = this.products[i].quantity * this.products[i].priceAfterDiscount;
					this.products[i].totalAfterDiscountAsString = currencyHelper.numberToCurrency(this.products[i].totalAfterDiscount);
				}
				this.products[i].total = this.products[i].quantity * this.products[i].basePrice;
				this.products[i].totalAsString = currencyHelper.numberToCurrency(this.products[i].total);
				this.products[i].selected = false;
			}
		},
		onFilterSearchClicked(){
			this.getDepotProducts()
		},
		onQuantityInput(product){
			console.log("product.selected", product.selected);
			product.selected = true;
			product.errorMessage = null;
			//this.hasError = false;
			if(product.quantity === null || product.quantity === ""){
				product.errorMessage = "Quantity is required";
				//this.hasError = true;
			}
			else if(product.quantity <= 0){
				product.quantity = 1;
			}

			product.total = product.quantity * product.price;
			product.totalAsString = currencyHelper.numberToCurrency(product.total);
			if(product.discountAmount !== null && product.discountAmount > 0){
				product.discountedAmountTotal = currencyHelper.roundToTwoDecimalPlaces(product.quantity * product.discountAmount);
				product.totalAfterDiscount = currencyHelper.roundToTwoDecimalPlaces(product.quantity * product.priceAfterDiscount);
				product.totalAfterDiscountAsString = currencyHelper.numberToCurrency(product.totalAfterDiscount);
			}
			this.calculateGrandTotalForOrder();
			this.onProductSelect(product, false);
		},
		calculateGrandTotalForOrder(){
			this.orderTotal = 0;
			for(let i = 0; i < this.products.length; i++){
				if(this.products[i].selected){
					if(this.products[i].discountAmount !== null && this.products[i].discountAmount > 0){
						this.orderTotal += this.products[i].totalAfterDiscount;
					}
					else {
						this.orderTotal += this.products[i].total;
					}
					this.orderTotal = currencyHelper.roundToTwoDecimalPlaces(this.orderTotal);
				}
			}
			this.orderTotalAsString = currencyHelper.numberToCurrency(this.orderTotal);
		},
		onProductSelect(product, canGetDiscount = true){
			let productsToOrder = {
				selectedProducts: [],
				hasError: false
			};
			
			// Track which combo groups need to be re-evaluated due to product unselection
			const affectedComboGroups = new Set();
			
			// Check if this product was unselected and had a combo discount
			if(!product.selected && product.hasComboDiscount){
				// Find which combo groups this product belonged to
				const productComboGroups = this.findComboDiscountGroupsForProduct(product.productId);
				productComboGroups.forEach(group => {
					affectedComboGroups.add(group.comboDiscountGroupId);
				});
			}
			
			// Collect all selected products and reset unselected products
			const allSelectedProducts = [];
			for(let i = 0; i < this.products.length; i++){
				if(this.products[i].selected){
					if(this.products[i].errorMessage !== null){
						productsToOrder.hasError = true;
					}
					allSelectedProducts.push(this.products[i]);
					productsToOrder.selectedProducts.push(this.products[i]);
				}
				else{
					this.products[i].selected = false;
					this.products[i].errorMessage = null;
					this.products[i].quantity = 1;
					this.products[i].total = this.products[i].quantity * this.products[i].price;
					this.products[i].totalAsString = currencyHelper.numberToCurrency(this.products[i].total);
					// Reset discount info when deselecting
					this.products[i].discountAmount = null;
					this.products[i].discountedAmountTotal = 0;
					this.products[i].discountAmountAsString = null;
					this.products[i].priceAfterDiscount = null;
					this.products[i].priceAfterDiscountAsString = null;
					this.products[i].totalAfterDiscount = null;
					this.products[i].totalAfterDiscountAsString = null;
					this.products[i].hasComboDiscount = false;
				}
			}
			
			// If any combo groups were affected by product unselection, remove their discounts
			if(affectedComboGroups.size > 0){
				affectedComboGroups.forEach(groupId => {
					this.removeComboDiscountFromGroup(groupId);
				});
				
				// Re-evaluate all discounts for remaining selected products
				if(allSelectedProducts.length > 0){
					this.reEvaluateDiscountsForSelectedProducts();
				}
				this.$emit("productSelected", productsToOrder);
				this.calculateGrandTotalForOrder();
				return;
			}
			
			console.log("productsToOrder", productsToOrder);

			if(canGetDiscount && product.selected){
				// First, reset all combo discounts to avoid stale data
				for(let i = 0; i < this.products.length; i++){
					if(this.products[i].selected){
						this.products[i].hasComboDiscount = false;
					}
				}
				
				// Start regular discount API calls for all selected products that need them
				const regularDiscountPromises = [];
				for(let i = 0; i < this.products.length; i++){
					if(this.products[i].selected && !this.products[i].discountAmount){
						const currentProduct = this.products[i];
						currentProduct.loading = true;
						let request = {
							productId: currentProduct.productId,
							companyId: this.companyId,
							depotId: this.depotId
						};

						const promise = orderService.getDiscountForCompanyAndProduct(request).then(
							successResponse => {
								let isSuccess = apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(successResponse.data.responseStatus, successResponse.data.httpStatusCode, successResponse.data.message);
								if(isSuccess){
									let response = successResponse.data;
									if(response.hasDiscountAmount){
										currentProduct.discountAmount = response.discountAmount;
										currentProduct.discountedAmountTotal = currencyHelper.roundToTwoDecimalPlaces(currentProduct.quantity * currentProduct.discountAmount);
										currentProduct.discountAmountAsString = currencyHelper.numberToCurrency(currentProduct.discountAmount);
										currentProduct.priceAfterDiscount = currencyHelper.roundToTwoDecimalPlaces(currentProduct.price - currentProduct.discountAmount);
										currentProduct.priceAfterDiscountAsString = currencyHelper.numberToCurrency(currentProduct.priceAfterDiscount);
										currentProduct.totalAfterDiscount = currencyHelper.roundToTwoDecimalPlaces(currentProduct.quantity * currentProduct.priceAfterDiscount);
										currentProduct.totalAfterDiscountAsString = currencyHelper.numberToCurrency(currentProduct.totalAfterDiscount);
									}
								}
								currentProduct.loading = false;
							},
							errorResponse => {
								console.log("errorResponse", errorResponse);
								apiResponseHandlerHelepr.displaySessionExpiredMessage(errorResponse.response.status);
								currentProduct.loading = false;
							}
						);
						regularDiscountPromises.push(promise);
					}
				}
				
				// Wait for all regular discount API calls to complete, then check for combo discounts
				if(regularDiscountPromises.length > 0){
					Promise.all(regularDiscountPromises).then(() => {
						// Now check for combo discounts and override regular discounts if applicable
						this.evaluateAndApplyComboDiscounts(allSelectedProducts);
						this.calculateGrandTotalForOrder();
						this.$emit("productSelected", productsToOrder);
					});
				} else {
					// No regular discount API calls needed, but still check for combo discounts
					this.evaluateAndApplyComboDiscounts(allSelectedProducts);
					this.calculateGrandTotalForOrder();
					this.$emit("productSelected", productsToOrder);
				}
			}
			else{
				this.$emit("productSelected", productsToOrder);
				this.calculateGrandTotalForOrder();
			}
		}
	},
	mounted: function () {
		this.getComboDiscountGroups();
	},
	watch:{
		depotId: {
			handler: function () {
				if(this.depotId !== null && this.companyId !== null){
					this.getDepotProducts();
				}
			},
			immediate: true,
			deep: true
		}
	}
};
